export const ROUTE_CONFIG = {
	LOGIN: "/login",
	REGISTER: "/register",
	TFA: "/2fa",
	LOGOUT: "/logout",
	FORGOT_PASSWORD: "/forgot-password",
	ERROR_PAGE: "/error-page",
	// APP: "/app",
	ACCOUNT: "/app/account",
	CRON: "/app/cron",
	ADMIN_FIXES: "/app/admin-fixes",
	API_HEALTH: "/app/api-health",
	COMPANY: "/app/company",
	BLACKLIST: "/app/blacklist",
	BLACKLIST_GLOBAL: "/app/blacklist/global",
	PITCHDECKS: "/app/pitchdecks",
	LISTS: "/app/lists",
	NEW_LIST: "/app/lists/create",
	LISTS_DETAIL: "/app/lists/detail",
	PROFILE_TRACKER: "/app/profile-tracker",
	FEED: "/app/feed",
	USERS: "/app/company?tab=USER",
	USER_ROLES: "/app/users/user-roles",
	JOBS: "/app/jobs",
	INDEED: "/app/indeed",
	NORTHDATA: "/app/bundesanzeiger",
	COMPANIES: "/app/companies",
	CSV_ENRICHMENTS: "/app/csvEnrichments",
	CUSTOM_EVENTS: "/app/custom-event",
	LINKEDIN_EVENTS: "/app/linkedin-events",
	LINKEDIN_COMPANY_ACTIVITY: "/app/linkedin-company-activity",
	LINKEDIN_POST: "/app/linkedin-posts",
	LINKEDIN_PROFILE_VISITS: "/app/linkedin-profile-visits",
	LINKEDIN_PROFILE: "/app/linkedin-profile",
	LINKEDIN_PEOPLE: "/app/linkedin-people-search",
	WORKFLOWS: "/app/workflow",
	ACCOUNTS: "/app/accounts",
	OPENAI: "/app/openai",
	DASHBOARD: "/app/dashboard",
	INBOX: "/app/inbox",
	SCORE: "/app/score",
	MESSAGE_CENTER: "/app/messages/ready-to-send",
	MESSAGE_CENTER_COMPOSE: "/app/messages/compose",
	MESSAGE_CENTER_INBOX: "/app/messages/inbox",
	MESSAGE_CENTER_OUTBOX: "/app/messages/outbox",
	MESSAGE_CENTER_FOLLOW_UP: "/app/messages/follow-up",
	MAPS: "/app/maps",
	CAMPAIGNS: "/app/campaigns",
	REPLIES: "/app/list-view/replies",
	NO_REPLY: "/app/list-view/no-reply",
	TO_BE_NURTURED: "/app/list-view/to-be-nurtured",
	DO_NOT_CONTACT: "/app/do-not-contact",
	DO_NOT_CONTACT_COMPETITORS: "/app/do-not-contact/competitors",
	DO_NOT_CONTACT_BLACKLIST: "/app/do-not-contact/blacklist",
	DO_NOT_CONTACT_SUPPRESSED: "/app/do-not-contact/suppressed",
	ONBOARDING: "/app/onboarding",
	ONBOARDING_CHAT: "/app/onboarding/chat",
	ONBOARDING_LISTS: "/app/onboarding/lists",
	ONBOARDING_TRACK: "/app/onboarding/track",
	ONBOARDING_PRIME: "/app/onboarding/prime",
	ONBOARDING_DONE: "/app/onboarding/done",
	ONBOARDING_SUBSCRIPTION: "/app/onboarding/subscription",
	SELECT_SUBSCRIPTION: "/app/select-subscription",
	SELECT_SUBSCRIPTION_DONE: "/app/select-subscription/done",
	/** The slim onboarding for users joining a workspace that is already set up. */
	ONBOARDING_V3: "/app/onboarding-v3",
	LEAD_SCORING: "/app/lead-scoring",
	LEAD_SCORING_GENERAL: "/app/lead-scoring/general",
	LEAD_SCORING_COMPANY: "/app/lead-scoring/company",
	LEAD_SCORING_PROSPECT: "/app/lead-scoring/prospect",
	LEAD_SCORING_OVERVIEW: "/app/lead-scoring/overview",
	LEAD_SCORING_CRITERIA: "/app/lead-scoring/scoring",
	LEAD_SCORING_JOB_TITLES: "/app/lead-scoring/job-titles",
	LEAD_SCORING_LOADING: "/app/lead-scoring/loading",
	CONFIRM_EMAIL: "/confirm-email",
	VERIFY_EMAIL: "/verify-email",
	ANALYTICS: "/app/analytics",
	APPLICATION_STATUS: "/application-status",
	TEMPLATES: "/app/templates",
	COPYWRITING: "/app/copywriting",
	SIGNALS: "/app/signals",
	KNOWLEDGE_DB: "/app/knowledge-db",
	HELP_CENTER_ADMIN: "/app/help-admin",
	SUPPORT: "/app/support",
	SUPPORT_DASHBOARD: "/app/support-dashboard",
	TICKETS: "/app/tickets",
	FEATURE_USAGE: "/app/feature-usage",
	FEATURE_MANAGEMENT: "/app/feature-management",
	CONTACTS: "/app/contacts",
	CONTACTS_COMPANIES: "/app/contacts/companies",
	HUBSPOT_CALLBACK: "/hubspot/callback",
	ZOHO_CALLBACK: "/zoho/callback",
	PIPEDRIVE_CALLBACK: "/pipedrive/callback",
	MSDYNAMICS_CALLBACK: "/msdynamics/callback",
	SALESFORCE_CALLBACK: "/salesforce/callback",
	PRIVACY_POLICY: "/privacy-policy",
	INTEGRATIONS: "/app/integrations",
	INTEGRATIONS_HUBSPOT: "/app/integrations/hubspot",
	INTEGRATIONS_ZOHO: "/app/integrations/zoho",
	INTEGRATIONS_PIPEDRIVE: "/app/integrations/pipedrive",
	INTEGRATIONS_MSDYNAMICS: "/app/integrations/msdynamics",
	INTEGRATIONS_SALESFORCE: "/app/integrations/salesforce",
	INTEGRATIONS_LEMLIST: "/app/integrations/lemlist",
	INTEGRATIONS_MCP: "/app/integrations/mcp",
	INTEGRATIONS_N8N: "/app/integrations/n8n",
	INTEGRATIONS_API: "/app/integrations/api",
	INTEGRATIONS_WEBHOOKS: "/app/integrations/webhooks",
	INTEGRATIONS_WEBHOOK_DELIVERIES: "/app/integrations/webhooks/:webhookId/deliveries",
	/** Consent screen of the MCP OAuth flow (docs/brief-mcp-server.md §"Tier 4"). */
	MCP_CONSENT: "/oauth/consent",
};

export const PUBLIC_PAGES_AFTER_LOGIN = [
	ROUTE_CONFIG.FORGOT_PASSWORD,
	ROUTE_CONFIG.CONFIRM_EMAIL,
	// A logged-in user clicking the verification link must land here and consume
	// the token, not be redirected into the app with it unused (PREC-3876).
	ROUTE_CONFIG.VERIFY_EMAIL,
	ROUTE_CONFIG.APPLICATION_STATUS,
	ROUTE_CONFIG.HUBSPOT_CALLBACK,
	ROUTE_CONFIG.ZOHO_CALLBACK,
	ROUTE_CONFIG.PIPEDRIVE_CALLBACK,
	ROUTE_CONFIG.MSDYNAMICS_CALLBACK,
	ROUTE_CONFIG.SALESFORCE_CALLBACK,
	ROUTE_CONFIG.PRIVACY_POLICY,
	// A logged-in user landing here must stay here: this is where they approve an MCP client.
	ROUTE_CONFIG.MCP_CONSENT,
];
